import { StyleSheet } from 'react-native';
import { heightPercentageToDP as hp } from 'react-native-responsive-screen';

export const styles = StyleSheet.create({
  orderItemContainer: {
    zIndex: 0,
  },
  textOrderIdLarge: {
    marginLeft: 15,
    fontSize: 16,
    fontWeight: '500',
    textAlign: 'center',
    lineHeight: 24,
    letterSpacing: 0,
    color: '#FFFFFF',
  },
  textOrderIdSmall: {
    fontSize: 14,
    fontWeight: '500',
    textAlign: 'left',
    lineHeight: 24,
    letterSpacing: 0,
    color: '#FFFFFF',
  },
  textOrderDateTimeLarge: {
    fontSize: 12,
    fontWeight: '400',
    textAlign: 'left',
    lineHeight: 24,
    letterSpacing: 0,
    color: '#FFFFFF',
  },
  textOrderDateTimeSmall: {
    fontSize: 9,
    fontWeight: '400',
    textAlign: 'left',
    lineHeight: 24,
    letterSpacing: 0,
    color: '#FFFFFF',
  },
  textCarModelSmall: {
    fontSize: 14,
    fontWeight: '500',
    textAlign: 'center',
    lineHeight: 24,
    letterSpacing: 0,
    color: '#FFFFFF',
  },
  textCarPlateSmall: {
    fontSize: 9,
    fontWeight: '400',
    textAlign: 'center',
    lineHeight: 24,
    letterSpacing: 0,
    color: '#FFFFFF',
  },
  cardOrderItemLarge: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'space-evenly',
    alignSelf: 'center',
    alignItems: 'center',
    paddingVertical: 15,
    paddingHorizontal: 20,
    height: hp('50%'),
    width: '90%',
    backgroundColor: '#001C47',
    borderRadius: 5,
  },
  cardOrderItemSmall: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'space-evenly',
    alignSelf: 'center',
    alignItems: 'center',
    paddingVertical: 8,
    paddingRight: 24,
    paddingLeft: 16,
    height: 60,
    width: '90%',
    marginTop: 5,
    backgroundColor: '#001C47',
    borderRadius: 5,
  },
  iconDefault: {
    marginTop: 2,
    alignSelf: 'center',
    color: '#0F6657',
  },
  containerIcon: {
    backgroundColor: '#fff',
    borderRadius: 15,
    width: 35,
    height: 35,
  },
  whatsappIconLarge: {
    alignSelf: 'center',
    borderWidth: 0,
    borderRadius: 20,
    marginLeft: 10,
    marginRight: 10,
  },
  whatsappIconSmall: {
    alignSelf: 'flex-end',
    borderWidth: 0,
    borderRadius: 20,
    marginLeft: 5,
    marginRight: 5,
  },
});
